import { useQuery } from "@tanstack/react-query";
import { authHttpClient } from "@/api/client";
import type { HovedenhetTilgangResponse } from "@/api/generated";
import { getAuthMeOptions } from "@/api/generated/@tanstack/react-query.gen";
import { parseOrgNr } from "../forms";

export type Aktoer = HovedenhetTilgangResponse;

export const useAktoerData = () => {
  const query = useQuery({
    ...getAuthMeOptions({
      client: authHttpClient,
    }),
  });

  const hovedenheter = query.data?.organisasjonsTilgang;

  // API used to return a list of organizations, but now only returns one hovedenhet
  const allAktoerer: Aktoer[] = hovedenheter != null ? [hovedenheter] : [];

  // Synchronous helper that always uses the latest data
  const getAktoerByOrgNr = (
    organisasjonsnummer: string | number,
  ): Aktoer | null => {
    const orgNr = Number.isInteger(organisasjonsnummer)
      ? organisasjonsnummer
      : parseOrgNr(organisasjonsnummer as string);
    return (
      allAktoerer.find(
        (l) => l?.organisasjonsnummer === orgNr && l?.tilgang === "write",
      ) || null
    );
  };

  return {
    ...query,
    data: allAktoerer,
    getAktoerByOrgNr,
  };
};
